export default __webpack_public_path__ + "static/media/svg-1.ed9dd57c.svg";